<template>
  <a ref="telButton" v-show="false" :href="`tel:${$route.params.tel}`" />
</template>
<script>
export default {
  mounted() {
    this.$refs.telButton.click();
    this.$router.back();
  },
};
</script>
